import { getCustomCSSClassesTraits } from '../commonTraitsMethod/preBuiltClassesTraits';
import { bootstrap4CSS } from './constant';

export default async function (editor, opt = {}) {
  const traitManager = editor.TraitManager;
  const { customCSSClasses: classTraitOpts } = await getCustomCSSClassesTraits(
    opt.projectId,
    opt.version,
  );
  const { bootstrap4Classes } = bootstrap4CSS;
  traitManager.addType(opt.traits.text.type, {
    createInput({ trait }) {
      let input = document.createElement('select');
      let attrId = document.createAttribute('id');
      attrId.value = 'drapcode-prebuilt-class-select';
      input.setAttributeNode(attrId);

      let optGroupForCustomClasses = document.createElement('optgroup');
      optGroupForCustomClasses.label = 'Custom CSS Classes';
      let optGroupForBootstrap4Classes = document.createElement('optgroup');
      optGroupForBootstrap4Classes.label = 'Bootstrap CSS Classes';

      let defaultOption = document.createElement('option');
      defaultOption.text = '- Select One -';
      defaultOption.value = '';
      input.append(defaultOption);

      for (let i = 0; i < classTraitOpts.length; i++) {
        let name = classTraitOpts[i].name;
        let value = classTraitOpts[i].value;
        let option = document.createElement('option');
        option.text = name;
        option.value = value;
        optGroupForCustomClasses.append(option);
        input.append(optGroupForCustomClasses);
      }
      for (let i = 0; i < bootstrap4Classes.length; i++) {
        let name = bootstrap4Classes[i].name;
        let value = bootstrap4Classes[i].value;
        let option = document.createElement('option');
        option.text = name;
        option.value = value;
        optGroupForBootstrap4Classes.append(option);
        input.append(optGroupForBootstrap4Classes);
      }
      return input;
    },
    onEvent({ elInput, component }) {
      const value = this.model.get('value');
      // const name = this.model.get('name');
      // const type = this.model.get('type');
      // let compClasses = component.getClasses();

      if (value) {
        let resultArr = [];
        resultArr.push(value);

        resultArr.forEach((cls) => {
          component.addClass(cls);
        });

        const traitsSize = component.get('traits').length;
        const globalClassTraits = component
          .get('traits')
          .filter((trait) => trait.attributes['type'] === 'drapcode-prebuilt-classes');

        component.addTrait(
          {
            type: `drapcode-prebuilt-classes`,
            name: `data-drapcodeClass-${globalClassTraits.length}`,
            label: `Global Class #${globalClassTraits.length}`,
          },
          { at: traitsSize },
        );
      }
      // } else {
      //   if (compClasses.length > 0) {
      //     compClasses.forEach(cls => {
      //       if (cssClassArray.includes(cls)) component.removeClass(cls);
      //     });
      //   }
      // }
    },
    onUpdate({ elInput, component }) {
      const attr = component.getAttributes();
      const name = this.model.get('name');
      // const type = this.model.get('type');
      // let compClasses = component.getClasses();

      elInput.value = attr[name] ? attr[name].trim() : '';
    },
  });
}
